import { Injectable } from '@angular/core';

import { OfferSource } from '@cds';
import { PopularBetsOptionTeamInfo } from '@cds/betting-offer/domain-specific/popular-bets';
import { EventOption, EventParticipant } from '@frontend/sports/betting-offer/feature/model';
import { GridEvent } from '@frontend/sports/grid/core/feature/model';

@Injectable({
    providedIn: 'root',
})
export class PopularBetsPodEventParticipantService {
    private getOptionPlayerId(eventOption: EventOption, offerSource: OfferSource): number | undefined {
        return offerSource === OfferSource.V1 ? eventOption.playerId : eventOption.optionPlayerId;
    }

    getOptionTeamId(eventOption: EventOption, optionTeamInfo: PopularBetsOptionTeamInfo[]): number | undefined {
        return optionTeamInfo.find((option) => option.optionId === eventOption.id)?.teamId;
    }

    private findParticipantById(
        participants: EventParticipant[],
        optionPlayerId: number,
        event: GridEvent,
        isOpponent: boolean = false,
        isTeamIdMapped: boolean = false,
    ): EventParticipant | undefined {
        const getId = (p: EventParticipant) => (isTeamIdMapped || event.offerSource === OfferSource.V1 ? p.id : p.fixtureParticipantId);

        return participants.find((p) => (isOpponent ? getId(p) !== optionPlayerId : getId(p) === optionPlayerId));
    }

    getOpponentParticipantFromOption(
        eventOption: EventOption,
        event: GridEvent,
        podOptionTeamInfo?: PopularBetsOptionTeamInfo[],
    ): EventParticipant | undefined {
        const optionTeamId = podOptionTeamInfo ? this.getOptionTeamId(eventOption, podOptionTeamInfo) : undefined;
        const playerId = !optionTeamId ? this.getOptionPlayerId(eventOption, event.offerSource) : null;
        const participantId = optionTeamId ?? playerId;
        if (!participantId) return undefined;

        return this.findParticipantById(event.participants, participantId, event, true, optionTeamId ? true : false);
    }

    mapEventWithFilteredParticipants(event: GridEvent): EventParticipant[] {
        if (event.participants.length > 2) {
            return event.participants.filter((p) => p.source === event.offerSource);
        }
        return event.participants;
    }
}
